<template>
  <div
    class="app-upload-button"
    :class="[borderColorClass(), bgColorClass()]"
    tabindex="0"
    v-on="$listeners"
    @keydown.enter="$emit('click')"
  >
    <slot
      v-if="$slots.default"
    />

    <div
      v-else-if="text"
      class="text-lg"
      v-text="text"
    />
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'AppUploadButton',

  mixins: [theme],

  // Props
  props: {
    text: {
      type: String,
      default: ''
    },

    theme: {
      type: String,
      default: 'green'
    }
  }

}
</script>

<style scoped lang="scss">
.app-upload-button {
  @apply h-50 sm:h-60 md:h-50 w-260 cursor-pointer;
  @apply flex justify-center items-center rounded-full;
  @apply m-auto font-semibold focus:outline-none border;
  @apply bg-opacity-20;

  transition: transform 150ms ease-out;

  &:hover {
    transform: translateY(-1px);
  }
}
</style>
